import Action from './modules/Action';

new Action().render();

const $body = $('body');

// $('form.js-validation').each((index, form) => {
//   const $form = $(form);
//   new FormValidation({ $form }).render();
// });

$body.on('input', '.js-submit', { passive: true }, (event) => {
  $(event.currentTarget).parents('form').submit();
});

$('.js-slider').each((index, element) => {
  const $slider = $(element);

  $slider.slick($slider.data('slider') || {});
});

$body.on('click', '.js-qty--minus', { passive: true }, (event) => {
  const $this = $(event.currentTarget);
  const $qty = $this.parents('.js-qty').find('.js-qty--input');
  const qty = parseInt($qty.val(), 10);

  if (qty > 1) $qty.val(qty - 1);
  return false;
});

$body.on('blur', '.js-blur-submit', { passive: true }, (event) => {
  const $this = $(event.currentTarget);

  $this.parents('form').submit();
});

$body.on('click', '.js-qty--plus', { passive: true }, (event) => {
  const $this = $(event.currentTarget);
  const $qty = $this.parents('.js-qty').find('.js-qty--input');
  const qty = parseInt($qty.val(), 10);
  const stock = parseInt($qty.attr('max'), 10);

  if (qty < stock || !stock) $qty.val(qty + 1);
  return false;
});

$('.js-redirect').on('change', { passive: true }, (event) => {
  const $this = $(event.currentTarget);

  document.location.href = $this.val();
});

$('.js-submit').on('change', { passive: true }, (event) => {
  const $this = $(event.currentTarget);
  const $form = $this.parents('form');

  $form.submit();
});

const $jsContentMore = $('.js-content-more');
$(window).on('resize load', { passive: true }, (event) => {
  const $this = $(event.currentTarget);

  if ($this.width() < 768) {
    $jsContentMore.addClass('content-more js-content-more--init');
  } else {
    $jsContentMore.removeClass('content-more');
  }
});

$body.on('click', '.js-content-more--init', { passive: true }, (event) => {
  const $this = $(event.currentTarget);

  $this.addClass('--active');
});

function matchStart(params, data) {
  const isOnline = $('.js-select-match--is-online').val();

  console.log(isOnline, data.text, data.element.dataset.filterIsOnline);

  if (data.element.dataset.filterIsOnline === isOnline) {
    return data;
  }

  return null;
}

$('.js-select-match--input').select2({
  matcher: matchStart,
});

$('.js-select').select2();

// карта
const $locationData = $('.js-location--data');
const locationData = JSON.parse($locationData.val() || '{ "data": { "geo_lat": 54.98, "geo_lon": 82.89 } }');
if ($locationData.length) {
  let map;
  let marker;
  const eventLocationInput = document.getElementById('event_location_input');

  DG.then(() => {
    map = DG.map('event_location', {
      center: [locationData.data.geo_lat, locationData.data.geo_lon],
      zoom: 13,
    });

    DG.control.location().addTo(map);

    if (locationData.data.geo_lat) {
      marker = DG.marker([locationData.data.geo_lat, locationData.data.geo_lon]).addTo(map);
    }

    map.locate({ setView: true, watch: true })
      .on('locationfound', (e) => {
        marker = DG.marker([e.latitude, e.longitude]).addTo(map);
      })
      .on('locationerror', (e) => {
        DG.popup()
          .setLatLng(map.getCenter())
          .setContent('Доступ к определению местоположения отключён')
          .openOn(map);
      });

    map.on('click', (e) => {
      const url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/geolocate/address';
      const token = '9621f08174dbaa81186300fd8fdfb1db96ebbef5';
      const query = { lat: e.latlng.lat, lon: e.latlng.lng };

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(query),
      };

      if (marker) marker.remove();
      marker = DG.marker([e.latlng.lat, e.latlng.lng]).addTo(map);

      fetch(url, options)
        .then((response) => response.text())
        .then((result) => {
          const data = JSON.parse(result);
          const address = data.suggestions[0].value;

          eventLocationInput.value = address;
          marker.bindPopup(address);

          $locationData.val(JSON.stringify(data.suggestions[0]));
        })
        .catch((error) => console.log('error', errr));
    });
  });

  // заполнение адреса
  const token = '9621f08174dbaa81186300fd8fdfb1db96ebbef5';

  const type = 'ADDRESS';
  const $locationFullAddress = $('.js-location--full-address');

  // регион и район
  $locationFullAddress.suggestions({
    token,
    type,
    hint: false,
    onSelect(suggestion) {
      console.log(suggestion);
      $locationData.val(JSON.stringify(suggestion));

      if (marker) marker.remove();
      marker = DG
        .marker(
          [suggestion.data.geo_lat, suggestion.data.geo_lon],
        )
        .addTo(map);

      map.setView([suggestion.data.geo_lat, suggestion.data.geo_lon]);
    },
  });
}

const $datepicker = $('.js-datepicker');
if ($datepicker.length) {
  $.datepicker.setDefaults($.datepicker.regional.ru);

  $datepicker.datepicker({
    minDate: new Date(),
    numberOfMonths: 1,
    onSelect(dateText) {
      const [day, month, year] = dateText.split('.');

      $.ajax({
        data: { isNaked: 1, search: { date: `${year}-${month}-${day}` } },
        success(response) {
          const $response = $(response);

          $('.js-events--items').html($response.find('.js-events--items').html());
        },
      });
    },
  });
}
